import { AlertResponse, DownloadExcelData, communicationsData } from "@/types/api-response";

export type quickActionsSliceState = {
  alertCount: number;
  downloadsCount: number;
  communicationsCount: number;
  downloadsData: any;
  communicationsData:any;
  alertsData:any
};

export const quickActionsSliceInitialState: quickActionsSliceState =
  (() => {
    return {
  alertCount: 0,
  downloadsCount: 0,
  communicationsCount: 0,
  downloadsData: {},
  communicationsData:{},
  alertsData:{}
    };
  })();
